<template>
  <div
    class="searchbar"
    :style="{
      transform: `translateY(${shown ? '0' : '40px'}) scaleY(${
        shown ? 1 : 0
      }) `,
    }"
  >
    <div
      class="body"
      :style="{
        marginRight: `calc(${triangleMargin} / 2)`,
      }"
    >
      <input
        ref="searchInput"
        type="text"
        @input="$emit('change', $event.target.value)"
        autocomplete="off"
        spellcheck="false"
      />
    </div>
    <div
      class="triangle"
      :style="{
        marginRight: triangleMargin,
      }"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'Searchbar',
  props: {
    shown: Boolean,
    triangleMargin: String,
  },
  created() {
    // Ctrl + F -> Open searchbar
    // Escape -> Close searchbar
    document.addEventListener(
      'keydown',
      (e) => {
        if (e.ctrlKey && e.key.toLowerCase() === 'f') {
          e.preventDefault();
          e.stopPropagation();

          this.$emit('show', true);
          this.$refs.searchInput.focus();
        }

        if (e.key === 'Escape') {
          this.$emit('show', false);
        }
      },
      false
    );
  },
  watch: {
    shown() {
      if (this.shown) {
        this.$refs.searchInput.focus();
      } else {
        this.$refs.searchInput.blur();
        this.$emit('change', '');
        this.$refs.searchInput.value = '';
      }
    },
  },
};
</script>

<style lang="scss">
.searchbar {
  transition: transform 100ms;
  overflow: hidden;

  $triangle-size: 25px;

  $searchbar-color: $logo-orange;

  filter: drop-shadow(0px 0px 10px $basic-dark);

  .body {
    margin: 0 auto;
    width: 60%;

    @include flex-center();

    height: 80px - $triangle-size;
    border-radius: 80px - $triangle-size / 2;
    background: $searchbar-color;
  }

  .triangle {
    height: $triangle-size;
    width: $triangle-size;
    margin-left: auto;
    margin-top: -1px;
    background: $searchbar-color;
    clip-path: polygon(100% 0, 0 0, 100% 100%);
  }

  input {
    width: 90%;
    height: 70%;
    background: none;
    border: none;
    outline: none;

    color: white;
    text-indent: 5px;
    font-size: 1.3em;
    border-bottom: 4px solid white;
    border-radius: 2px;
  }
}
</style>
